import { createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withModifiers as _withModifiers, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6048fea3")

_pushScopeId("data-v-6048fea3")
const _hoisted_1 = { class: "fast_box" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "fast_title flex_start_center" }, [
  /*#__PURE__*/_createVNode("i", { class: "fast_icon" }),
  /*#__PURE__*/_createTextVNode(" 检测到您历史登录账号，请点击登录 ")
], -1)
const _hoisted_3 = { class: "fast_list" }
const _hoisted_4 = { class: "flex_start_center" }
const _hoisted_5 = { class: "user_info" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode("ul", null, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.viewModel.fastAccountList.filter((_, i) => i < 3), (item, index) => {
          return (_openBlock(), _createBlock("li", {
            class: "flex_start_center",
            key: index,
            onClick: ($event: any) => (_ctx.fastLoginAction(item.token, item.open_id))
          }, [
            _createVNode("i", {
              class: "hd_close",
              onClick: _withModifiers(($event: any) => (_ctx.removeFastAccountItem(index)), ["stop"])
            }, null, 8, ["onClick"]),
            _createVNode("div", _hoisted_4, [
              _createVNode("img", {
                src: item.avatar || _ctx.viewModel.defaultAvatar,
                class: "avater",
                onError: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.errorImg && _ctx.errorImg(...args)))
              }, null, 40, ["src"]),
              _createVNode("div", _hoisted_5, [
                _createVNode("span", null, _toDisplayString(item.name || ''), 1),
                _createVNode("div", null, _toDisplayString(_ctx.viewModel.loginTypeMap[item.login_type]), 1)
              ])
            ])
          ], 8, ["onClick"]))
        }), 128))
      ])
    ]),
    _createVNode("div", {
      class: "other_action_text",
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.useOtherAccountLogin && _ctx.useOtherAccountLogin(...args)))
    }, "使用其他账号登陆")
  ]))
})